import React from 'react';

import { Heading } from '../heading';
import { Input } from '../input';

import { HalfWidthContainer, StyledContentCard, StyledContentCardRow } from './query-builder.styles';

type EntityNameSectionProps = {
  headerSubHeaderCopy: string;
  headerTitle: string;
  inputDisabled?: boolean;
  inputLabel?: string;
  inputPlaceholder: string;
  inputValidationError?: string;
  inputValue: string;
  setInputValue: (value: string) => void;
};

export function EntityNameSection({
  headerSubHeaderCopy,
  headerTitle,
  inputDisabled = false,
  inputLabel = 'Name:',
  inputPlaceholder,
  inputValue,
  inputValidationError,
  setInputValue,
}: EntityNameSectionProps) {
  return (
    <StyledContentCard>
      <StyledContentCardRow>
        <HalfWidthContainer>
          <Heading level={4} marginBottom='0' subheader={headerSubHeaderCopy}>
            {headerTitle}
          </Heading>
        </HalfWidthContainer>
        <HalfWidthContainer>
          <Input
            disabled={inputDisabled}
            error={!!inputValidationError}
            errorMessage={inputValidationError}
            label={inputLabel}
            labelPlacement='top'
            maxlength={100}
            placeholder={inputPlaceholder}
            value={inputValue}
            onChange={({ target }) => setInputValue(target.value)}
          />
        </HalfWidthContainer>
      </StyledContentCardRow>
    </StyledContentCard>
  );
}
